import React from 'react'

const HeaderIcon = ({
  icon: Icon,
  count,
  iconProps,
  isMobile = false,
  onClick,
}) => {
  const desktopButtonClasses =
    'relative cursor-pointer p-2 rounded-full transition-all duration-300 flex items-center justify-center hover:bg-slate-100 hover:-translate-y-0.5'
  const mobileButtonClasses =
    'relative cursor-pointer w-10 h-10 bg-slate-100 rounded-full transition-all duration-300 flex items-center justify-center hover:bg-slate-200 hover:-translate-y-0.5 hover:shadow-sm'

  const desktopBadgeClasses =
    'absolute top-[2px] right-[2px] bg-[#FF424D] text-white rounded-full w-4 h-4 text-[11px] font-semibold flex items-center justify-center pt-[2px]'
  const mobileBadgeClasses =
    'absolute -top-1 -right-1 bg-[#FF424D] text-white rounded-full w-[15px] h-[15px] text-[9px] font-semibold flex items-center justify-center'

  return (
    <button
      onClick={onClick}
      className={isMobile ? mobileButtonClasses : desktopButtonClasses}
    >
      <Icon
        {...iconProps}
        className={isMobile ? 'text-slate-600' : ''}
        width={isMobile ? 20 : 27}
        height={isMobile ? 20 : 27}
      />
      {count > 0 && (
        <span className={isMobile ? mobileBadgeClasses : desktopBadgeClasses}>
          {count}
        </span>
      )}
    </button>
  )
}

export default HeaderIcon
